import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import withFocusFirstInput from 'components/common/hoc/withFocusFirstInput'
import toggle from 'components/common/hoc/toggle'
import PasswordAndSecurityDrawer from './PasswordAndSecurityDrawer'
import { updatePassword } from './actions'

const withUpdatePasswordAction = withHandlers({
  handleUpdatePassword: ({ updatePassword, accountContactDetails: { emailId }}) => values =>
    updatePassword(emailId, values)
})

export default compose(
  connect(null, { updatePassword }),
  withUpdatePasswordAction,
  toggle,
  withFocusFirstInput
)(PasswordAndSecurityDrawer)
